export default __webpack_public_path__ + "static/img_we_1@2x-9a6eb2b6f2efc051e8eb3d9a04ea0841.png";